var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page bg-white" },
    [
      _vm.type === "table"
        ? _c(
            "el-table",
            { attrs: { border: "", data: _vm.chartData.rows } },
            _vm._l(_vm.chartData.columns, function (column, index) {
              return _c("el-table-column", {
                key: index,
                attrs: { prop: column, label: column },
              })
            }),
            1
          )
        : _vm.custom
        ? _c("ve-" + _vm.type, {
            tag: "component",
            attrs: {
              data: _vm.chartData,
              legend: _vm.activeOption.legend,
              grid: _vm.activeOption.grid,
              extend: _vm.activeOption.extend,
              tooltip: _vm.activeOption.tooltip,
              colors: _vm.activeOption.colors,
              title: _vm.activeOption.title,
            },
          })
        : _c("ve-" + _vm.type, {
            tag: "component",
            attrs: { data: _vm.chartData },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }